import React from "react";
import ActiveOrdersMonitorUI from "./components/ActiveOrdersMonitorUI";

const ActiveOrdersMonitor = () => {
  return <ActiveOrdersMonitorUI />;
};

export default ActiveOrdersMonitor;
